import { useLayoutEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "../modules.css";
import { globalVariables } from "helper/globalVariables";
import { TextInput } from "shared/Components/textInput";
import { hostDetailsResolver } from "validators/UserValidation";
import { Button } from "shared/Components/button";
import { useDispatch, useSelector } from "react-redux";
import { setHostDetails } from "redux/features/hostSlice/addTrialSlice/addTrialSlice";
import { StepsHeader } from "shared/Components/stepsHeader";
import { SectionHeading } from "../common/SectionHeading";
import { SearchLocation } from "shared/Components/searchLocation";
import { SearchDropdown } from "shared/Components/searchDropdown";
import { usStatesList } from "container/MyProfile/Components/constants";

export const HostDetails = ({ onTapNext }) => {
  const { auth } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [checkValidation, setCheckValidation] = useState(false);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");

  useLayoutEffect(() => {
    getHostDetails();
  }, []);

  const getHostDetails = async () => {
    if (auth?.addTrialReducer?.hostDetails) {
      const hostDetails = auth?.addTrialReducer?.hostDetails;
      setValue("hostName", hostDetails?.hostName);
      setValue("contactAddress", hostDetails?.contactAddress);
      setValue("hostPaypalEmail", hostDetails?.hostPaypalEmail);
      setValue("paypalPaymentLink", hostDetails?.paypalPaymentLink);
      setValue("trialSecretaryName", hostDetails?.trialSecretaryName);
      setValue(
        "trialSecretaryEmailAddress",
        hostDetails?.trialSecretaryEmailAddress
      );
      setValue("zip", hostDetails?.zip);
      setValue("city", hostDetails?.city);
      setValue("state", hostDetails?.state);
      setCity(hostDetails?.city);
      setState(hostDetails?.state);
    } else {
      const {
        first_name,
        last_name,
        location_address,
        email,
        city,
        state,
        zipCode,
      } = auth?.memberReducer?.memberDetails || {};

      setValue("hostName", `${first_name} ${last_name}`);
      setValue("contactAddress", location_address);
      setValue("hostPaypalEmail", email);
      setValue("zip", zipCode);
      setValue("city", city);
      setValue("state", state);
      setCity(city);
      setState(state);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: hostDetailsResolver,
    defaultValues: {
      hostName: "",
      contactAddress: "",
      hostPaypalEmail: "",
      paypalPaymentLink: "",
      trialSecretaryName: "",
      trialSecretaryEmailAddress: "",
      zip: "",
    },
  });

  const onCheckValidation = () => {
    setCheckValidation(true);
  };

  const onHandleSubmit = async (credentials) => {
    if (city && state) {
      dispatch(setHostDetails({ ...credentials, city, state }));
      onTapNext?.();
    }
  };
  const innerContainerClass = "block lg:flex flex-row w-full lg:w-auto";

  return (
      <div className="flex justify-center flex-col items-center">
        <StepsHeader
          step={1}
          labels={[
            globalVariables.hostDetails,
            globalVariables.trialDetails,
            globalVariables.searchDetails,
          ]}
        />
        <SectionHeading heading={globalVariables.hostDetails} />

        <form
          className="lg:w-full items-center flex  pb-[50px] flex-col md:pb-[0px] max-[400px]:w-[90%]"
          onSubmit={handleSubmit(onHandleSubmit)}
        >
          <div className="max-[400px]:w-[100%]">
            <div className={innerContainerClass}>
              <TextInput
                register={register}
                name="hostName"
                placeholder={globalVariables.hostName}
                label={globalVariables.hostName}
                errorMsg={errors.hostName?.message}
              />
              <div className="mt-[10px] lg:mt-0 mr-0 lg:mr-5" />
              <TextInput
                register={register}
                name="trialSecretaryName"
                placeholder={globalVariables.trialSecretaryName}
                label={globalVariables.trialSecretaryName}
                errorMsg={errors.trialSecretaryName?.message}
              />
            </div>
            <div className="mt-[10px] lg:mt-5" />
            <div className={innerContainerClass}>
              <TextInput
                register={register}
                name="contactAddress"
                placeholder={globalVariables.contactAddress}
                label={globalVariables.contactAddress}
                errorMsg={errors.contactAddress?.message}
              />
              <div className="mt-[10px] lg:mt-0 mr-0 lg:mr-5" />
                <SearchLocation
                  register={register}
                  icon="right"
                  name="state"
                  defaultValue={state}
                  placeholder={globalVariables.state}
                  label={globalVariables.state}
                  types={["(regions)"]}
                  onSelectLocation={(value) => {
                    setState(value);
                  }}
                  errorMsg={
                    !state && checkValidation
                      ? "Please select a state from the dropdown"
                      : ""
                  }
                />
            </div>
            <div className="mt-[10px] lg:mt-5" />
            <div className={innerContainerClass}>
              {" "}
                <SearchLocation
                register={register}
                icon="right"
                name="city"
                defaultValue={city}
                disabled={state === ""}
                placeholder={globalVariables.city}
                label={globalVariables.city}
                types={["(cities)"]}
                onSelectLocation={(location) => {
                  setCity(location);
                }}
                errorMsg={
                  !city && checkValidation
                    ? globalVariables.selectFromOption
                    : ""
                }
                searchBy={state}
              />
              <div className="mt-[10px] lg:mt-0 mr-0 lg:mr-5" />
              <TextInput
                register={register}
                name="zip"
                placeholder={globalVariables.zip}
                label={globalVariables.zip}
                errorMsg={errors.zip?.message}
                type="number"
              />
            </div>
            <div className="mt-[10px] lg:mt-5" />
            <div className={innerContainerClass}>
              <TextInput
                register={register}
                name="trialSecretaryEmailAddress"
                textTransform="normal-case"
                placeholder={globalVariables.trialSecretaryEmailAddress}
                label={globalVariables.trialSecretaryEmailAddress}
                errorMsg={errors.trialSecretaryEmailAddress?.message}
              />
              <div className="mt-[10px] lg:mt-0 mr-0 lg:mr-5" />
              <TextInput
                register={register}
                name="hostPaypalEmail"
                placeholder="payment@email.com"
                label="Payment Email (Required)"
                errorMsg={errors.hostPaypalEmail?.message}
                textTransform="normal-case"
              />
            </div>
            <div className="mb-6" />
            <div className="flex flex-col lg:flex-row">
              <TextInput
                register={register}
                name="paypalPaymentLink"
                placeholder="https://paypal.me/yourname or Stripe/Venmo payment link"
                label="Payment Link"
                errorMsg={errors.paypalPaymentLink?.message}
                textTransform="normal-case"
              />
            </div>
            <div className="text-sm text-gray-600 mt-1 mb-4">
              Add any payment link (PayPal.me, Stripe, Venmo, Square, etc.) Members will see a "Pay Now" button in the email. If no link is provided, they can pay via the payment email above.
            </div>
            <div className="mb-6" />
            <div className="hidden lg:flex justify-end">
              <Button
                onClick={onCheckValidation}
                label={globalVariables.next}
                width="w-32"
              />
            </div>
          </div>
          <div className="lg:hidden fixed bottom-0 w-screen p-[10px] flex row items-center justify-end bg-white border-t-2">
            <Button
              onClick={onCheckValidation}
              label={globalVariables.next}
              width="md:w-32 lg:w-32 w-full"
            />
          </div>
        </form>
      </div>
  );
};
